import "../type/checkPrice.js"
import InternalAPI from "../baseAxios.js";
import {API_VERSION } from "./helper.js";

/** @borrows InternalAPI */
export default class CheckShippingPriceRepository extends InternalAPI {
    constructor() {
        super();
        /** @type {string} */
        this.endpoint = "tariff"
        this.endpointProduct = "v2/product_detail/data"
        this.endpointBulky = 'v1/shipment/tariff'
    }

    /**
     *
     * @param queryString {string}
     * @returns {Promise<{data: ShippingPriceInfo, err: ErrorMapper}>
     */
    async getOneResult(queryString) {
        try {
            /** @type {import('axios').AxiosResponse<Object>} */
            const res = await this.$axios.get(`${API_VERSION}/${this.endpoint}${queryString}`);
            if (res.status === 200) {
                if (res.data) {
                    return {data: res.data, err: null}
                }
            }
            return {data: null, err: null}
        } catch (err) {
            let newErr = "unknown message"
            if (!err.response || !err.response.data) {
                newErr = "something went wrong"
            }
            if(err.response && err.response.data.message) {
                newErr = err.response.data.message
            }
            return {data: null, err: this.setErrorMessage(newErr)}
        }
    }

    async getProducts(inputSearch) {
        try {
            const res = await this.$axios.get(this.endpointProduct + "?" + inputSearch)
            if (res.status === 200) {
                if (res.data) {
                    return {data: res.data.data.data, err: null}
                }
            }
            return {data: [], err: null}
        } catch (err) {
            return {data: [], err: this.setErrorMessage(err.response.data.desc)}
        }
    }

    /**
     *
     * @param payload {{data: RequestCheckPriceBulky[], is_new_cod: boolean}}
     * @returns {Promise<{data: ResponseBulkyCheckPrice[] | null, total: null, parcel_point: null, err: *}>}
     */
    async bulkyCheckShippingPrice(payload) {
        payload.is_new_cod = true
        try {
            /** @type {import('axios').AxiosResponse<Object>} */
            const res = await this.$axios.post(`${this.endpointBulky}/bulk`, payload);
            if (res.status === 200) {
                if (res.data) {
                    return {
                        data: res.data.data,
                        total: res.data.total_ongkir,
                        parcel_point: res.data.parcel_point,
                        pickup_fee: res.data.pickup_fee,
                        pickup_fee_discount: res.data.pickup_fee_discount,
                        err: null
                    };
                }
            }
            return {data: null, total: null, parcel_point: null, err: null, pickup_fee: null, pickup_fee_discount: null};
        } catch (err) {
            return {data: null, total: null, parcel_point: null, pickup_fee: null, pickup_fee_discount: null, err: this.setErrorMessage(err)};
        }
    }
}
